const previewTool = document.getElementsByClassName('serppreview');
if (previewTool) {

    // Function to truncate a string
    String.prototype.trunc = function (n, useWordBoundary) {
        if (this.length <= n) {
            return this;
        }
        var subString = this.substr(0, n - 1);
        return (useWordBoundary ?
                subString.substr(0, subString.lastIndexOf(' ')) :
                subString) + "&hellip;";
    };

    // Function to replace URL
    function replaceUrl() {
        var userInput = document.getElementById('live_url').value;
        document.getElementById('preview_url').innerHTML = userInput;
    }

    // Function to measure text width
    function measureTextWidth(text, fontSize, fontFace) {
        var canvas = measureTextWidth.canvas || (measureTextWidth.canvas = document.createElement("canvas"));
        var context = canvas.getContext("2d");
        context.font = fontSize + 'px ' + fontFace;
        var metrics = context.measureText(text);
        return metrics.width;
    }

    // Function to truncate text
    function truncateText(text, maxWidth, fontSize, fontFace) {
        var ellipsis = '…';
        var truncatedText = '';
        var currentWidth = 0;
        var words = text.split(' ');
        var ellipsisWidth = measureTextWidth(ellipsis, fontSize, fontFace);

        for (var i = 0; i < words.length; i++) {
            var wordWidth = measureTextWidth(words[i], fontSize, fontFace);

            if (wordWidth > maxWidth) {
                var truncatedWord = words[i];
                while (measureTextWidth(truncatedWord, fontSize, fontFace) + ellipsisWidth > maxWidth) {
                    truncatedWord = truncatedWord.substring(0, truncatedWord.length - 1);
                }
                truncatedText += truncatedWord + ellipsis;
                break;
            }

            if (currentWidth + wordWidth + ellipsisWidth > maxWidth) {
                truncatedText += ellipsis;
                break;
            } else {
                truncatedText += (truncatedText.length > 0 ? ' ' : '') + words[i];
                currentWidth += wordWidth + (i > 0 ? measureTextWidth(' ', fontSize, fontFace) : 0);
            }
        }

        if (truncatedText.length === 0) {
            return text;
        }

        return truncatedText;
    }

    // Function to replace title
    function replaceTitle() {
        var userInput = document.getElementById('live_title').value;
        var maxWidth = 600;
        var fontSize = 20;
        var fontFace = 'Arial';
        var truncatedTitle = truncateText(userInput, maxWidth, fontSize, fontFace);
        document.getElementById('preview_title').innerHTML = truncatedTitle;
    }

    // Function to replace meta
    function replaceMeta() {
        var userInput = document.getElementById('live_meta').value;
        var charCount = userInput.length;
        document.getElementById('meta-char-count').textContent = charCount + " tekens / 155 tekens";
        var result = '';

        if (document.getElementById('checkbox3').checked) {
            var date = getDate();
            var editedUserInput = "<span class='date'>" + date + " - </span>" + userInput;
            result = editedUserInput.trunc(176, true);
        } else {
            result = userInput.trunc(155, true);
        }

        document.getElementById('preview_meta').innerHTML = result;

        if (userInput.length > 115) {
            document.getElementById('danger-description').style.display = 'block';
        } else {
            document.getElementById('danger-description').style.display = 'none';
        }
    }

    // Function to get date
    function getDate() {
        const monthNames = ["jan.", "feb.", "maart", "apr.", "mei", "juni", "juli", "aug.", "sept", "okt", "nov", "dec"];
        var date = new Date();
        var strDate = date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
        return strDate;
    }

    // Function to handle checkbox click
    function checkBoxClick() {
        if (document.getElementById('checkbox1').checked && document.getElementById('checkbox2').checked) {
            document.getElementById('insert').innerHTML = ' - ';
        } else {
            document.getElementById('insert').innerHTML = '';
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const checkbox1 = document.getElementById('checkbox1');
        const checkbox2 = document.getElementById('checkbox2');
        const checkbox3 = document.getElementById('checkbox3');
        const liveUrl = document.getElementById('live_url');
        const liveTitle = document.getElementById('live_title');
        const liveMeta = document.getElementById('live_meta');

        if (checkbox1) {
            checkbox1.addEventListener('change', function () {
                document.getElementById('BeoordelingOutput').style.display = this.checked ? 'block' : 'none';
                checkBoxClick();
            });
        }

        if (checkbox2) {
            checkbox2.addEventListener('change', function () {
                document.getElementById('PrijsOutput').style.display = this.checked ? 'block' : 'none';
                checkBoxClick();
            });
        }

        if (checkbox3) {
            checkbox3.addEventListener('change', function () {
                replaceMeta();
                checkBoxClick();
            });
        }

        if (liveUrl) {
            liveUrl.addEventListener('keyup', replaceUrl);
        }

        if (liveTitle) {
            liveTitle.addEventListener('keyup', replaceTitle);
        }

        if (liveMeta) {
            liveMeta.addEventListener('keyup', replaceMeta);
        }
    });
}
